
import { PythonCourse } from './types';
import { 
  PYTHON_ESSENTIALS_TRACK, 
  PYTHON_INTERMEDIATE_OOP_TRACK,
  PYTHON_ADVANCED_MASTERY_TRACK
} from './trackModules';

// Track definitions for Python courses - Now with 3 comprehensive tracks
export const PYTHON_TRACKS: PythonCourse[] = [
  PYTHON_ESSENTIALS_TRACK,
  PYTHON_INTERMEDIATE_OOP_TRACK,
  PYTHON_ADVANCED_MASTERY_TRACK
];

// Export individual tracks for backward compatibility
export { 
  PYTHON_ESSENTIALS_TRACK, 
  PYTHON_INTERMEDIATE_OOP_TRACK,
  PYTHON_ADVANCED_MASTERY_TRACK
};
